const stableObject = {};

const pipelineFiltersSelector = (state) => {
  const filters = state.ui.filters;
  const filterSet = ['overdueActions', 'locationId', 'servicePersonId', 'pipelineItemLastActivity', 'userId', 'pipelineTodos', 'lastReceived', 'lastContacted', 'hasUnreadInbox', 'serviceId', 'search', 'pipelineStageId'];
  let change = false;

  for (const key in stableObject) {
    if (!filterSet.includes(key)) {
      change = true;
      delete stableObject[key];
    }
  }

  filterSet.forEach((n) => {
    if (stableObject[n] !== filters[n]) {
      change = true;
      stableObject[n] = filters[n];
    }
  });

  return change ? { ...stableObject } : stableObject;
};

export default pipelineFiltersSelector;
